// ─────────────────────────────────────────────────────────────
//  Customer Acquisition heat-map — types & API transform.
//  rows = cohort years, columns = months (Jan..Dec)
// ─────────────────────────────────────────────────────────────
export const CA_MONTHS = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];
const EMPTY_CELL = { value: null, heatClass: null };
/**
 * Transform the API's `customer_acquisition_report` object into rows the
 * <CustomerAcquisition /> component renders. Years are ordered most-recent
 * first, and every row is padded to 12 months (index 0 = Jan).
 */
export const buildCustomerAcquisitionRows = (report) => {
    if (!report)
        return [];
    return Object.keys(report)
        .map((y) => Number(y))
        .filter((y) => !Number.isNaN(y))
        .sort((a, b) => a - b)
        .map((year) => {
        const monthsObj = report[String(year)] || {};
        const months = Array.from({ length: 12 }, (_, i) => {
            const cell = monthsObj[String(i + 1)];
            if (!cell)
                return EMPTY_CELL;
            // API sends counts as strings that may contain thousands separators
            // (e.g. "1,476") — strip non-numeric chars before parsing so they
            // don't become NaN → null → blank cell.
            const raw = cell.customer_count;
            const parsed = raw != null ? Number(String(raw).replace(/[^0-9.-]/g, "")) : NaN;
            const value = Number.isNaN(parsed) ? null : parsed;
            const heatClass = cell.category === "L" || cell.category === "LM" || cell.category === "M" || cell.category === "H"
                ? cell.category
                : null;
            return { value, heatClass };
        });
        return { year, months };
    });
};
